// import AirbrakeClient from "airbrake-js";

// import { hot } from "react-hot-loader/root";
import React from "react";

import "./AppleMusic.scss";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    // this.airbrake = new AirbrakeClient({
    //   projectId: 97675,
    //   projectKey: "227c5e7b9fddc294ed08550650e0f658",
    //   ignoreWindowError: true
    // });
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    // this.setState({ hasError: true });

    // Send error to Airbrake
    // this.airbrake.notify({
    //   error: error,
    //   params: { info: info }
    // });
    console.log("AppleMusic error: ", error);
    console.log("AppleMusic error info: ", info);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      let classNames = "apple-music-player song";

      return (
        <div className={classNames}>
          <div className="am__loading">
            <div className="am__loading__logo">
              <span className="logo" />
            </div>
          </div>
          <div className="error-message">
            We're sorry but something went wrong.
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
